"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUpdateAddressInfoCommand = exports.validateUpdatePersonalInfoCommand = exports.validateAddNotificationTokenCommand = exports.validateCreateUserRequest = void 0;
const typia_1 = __importDefault(require("typia"));
__exportStar(require("./address-info.dto"), exports);
exports.validateCreateUserRequest = (() => { const $guard = typia_1.default.createAssert.guard; const $io0 = input => "email-password" === input.type; const $io1 = input => "oauth" === input.type; const $iu0 = input => (() => {
    if ("oauth" === input.type)
        return $io1(input);
    else if ("email-password" === input.type)
        return $io0(input);
    else
        return false;
})(); const $ao0 = (input, _path, _exceptionable = true) => "email-password" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "\"email-password\"",
    value: input.type
}, _errorFactory); const $ao1 = (input, _path, _exceptionable = true) => "oauth" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "\"oauth\"",
    value: input.type
}, _errorFactory); const $au0 = (input, _path, _exceptionable = true) => (() => {
    if ("oauth" === input.type)
        return $ao1(input, _path, true && _exceptionable);
    else if ("email-password" === input.type)
        return $ao0(input, _path, true && _exceptionable);
    else
        return $guard(_exceptionable, {
            path: _path,
            expected: "(__type.o1 | __type)",
            value: input
        }, _errorFactory);
})(); const __is = input => "object" === typeof input && null !== input && $iu0(input); let _errorFactory; return (input, errorFactory) => {
    if (false === __is(input)) {
        _errorFactory = errorFactory;
        ((input, _path, _exceptionable = true) => ("object" === typeof input && null !== input || $guard(true, {
            path: _path + "",
            expected: "(__type | __type.o1)",
            value: input
        }, _errorFactory)) && $au0(input, _path + "", true) || $guard(true, {
            path: _path + "",
            expected: "(__type | __type.o1)",
            value: input
        }, _errorFactory))(input, "$input", true);
    }
    return input;
}; })();
exports.validateAddNotificationTokenCommand = (() => { const $guard = typia_1.default.createAssert.guard; const $io0 = input => "string" === typeof input.token; const $ao0 = (input, _path, _exceptionable = true) => "string" === typeof input.token || $guard(_exceptionable, {
    path: _path + ".token",
    expected: "string",
    value: input.token
}, _errorFactory); const __is = input => "object" === typeof input && null !== input && $io0(input); let _errorFactory; return (input, errorFactory) => {
    if (false === __is(input)) {
        _errorFactory = errorFactory;
        ((input, _path, _exceptionable = true) => ("object" === typeof input && null !== input || $guard(true, {
            path: _path + "",
            expected: "AddNotificationTokenCommand",
            value: input
        }, _errorFactory)) && $ao0(input, _path + "", true) || $guard(true, {
            path: _path + "",
            expected: "AddNotificationTokenCommand",
            value: input
        }, _errorFactory))(input, "$input", true);
    }
    return input;
}; })();
exports.validateUpdatePersonalInfoCommand = (() => { const $guard = typia_1.default.createAssert.guard; const $io0 = input => "initial" === input.status && "string" === typeof input.firstName && "string" === typeof input.lastName && "string" === typeof input.birthdate; const $io1 = input => "complete" === input.status && "string" === typeof input.firstName && "string" === typeof input.lastName && "string" === typeof input.birthdate && ("object" === typeof input.gender && null !== input.gender && $iu0(input.gender)) && ("object" === typeof input.pronouns && null !== input.pronouns && $iu1(input.pronouns)) && ("object" === typeof input.disabilityInfo && null !== input.disabilityInfo && $iu2(input.disabilityInfo)) && "boolean" === typeof input.student; const $io2 = input => "male" === input.type || "female" === input.type || "non-binary" === input.type; const $io3 = input => "other" === input.type && "string" === typeof input.other; const $io4 = input => "he" === input.type || "she" === input.type || "they" === input.type; const $io5 = input => "other" === input.type && "string" === typeof input.other; const $io6 = input => "boolean" === typeof input.mobility && "boolean" === typeof input.hearingVision && false === input.needsAccommodation; const $io7 = input => "boolean" === typeof input.mobility && "boolean" === typeof input.hearingVision && true === input.needsAccommodation && "string" === typeof input.accommodationDescription; const $iu0 = input => (() => {
    if ("male" === input.type || "female" === input.type || "non-binary" === input.type)
        return $io2(input);
    else if ("other" === input.type)
        return $io3(input);
    else
        return false;
})(); const $iu1 = input => (() => {
    if ("he" === input.type || "she" === input.type || "they" === input.type)
        return $io4(input);
    else if ("other" === input.type)
        return $io5(input);
    else
        return false;
})(); const $iu2 = input => (() => {
    if (false === input.needsAccommodation)
        return $io6(input);
    else if (true === input.needsAccommodation)
        return $io7(input);
    else
        return false;
})(); const $iu3 = input => (() => {
    if ("initial" === input.status)
        return $io0(input);
    else if ("complete" === input.status)
        return $io1(input);
    else
        return false;
})(); const $ao0 = (input, _path, _exceptionable = true) => ("initial" === input.status || $guard(_exceptionable, {
    path: _path + ".status",
    expected: "\"initial\"",
    value: input.status
}, _errorFactory)) && ("string" === typeof input.firstName || $guard(_exceptionable, {
    path: _path + ".firstName",
    expected: "string",
    value: input.firstName
}, _errorFactory)) && ("string" === typeof input.lastName || $guard(_exceptionable, {
    path: _path + ".lastName",
    expected: "string",
    value: input.lastName
}, _errorFactory)) && ("string" === typeof input.birthdate || $guard(_exceptionable, {
    path: _path + ".birthdate",
    expected: "string",
    value: input.birthdate
}, _errorFactory)); const $ao1 = (input, _path, _exceptionable = true) => ("complete" === input.status || $guard(_exceptionable, {
    path: _path + ".status",
    expected: "\"complete\"",
    value: input.status
}, _errorFactory)) && ("string" === typeof input.firstName || $guard(_exceptionable, {
    path: _path + ".firstName",
    expected: "string",
    value: input.firstName
}, _errorFactory)) && ("string" === typeof input.lastName || $guard(_exceptionable, {
    path: _path + ".lastName",
    expected: "string",
    value: input.lastName
}, _errorFactory)) && ("string" === typeof input.birthdate || $guard(_exceptionable, {
    path: _path + ".birthdate",
    expected: "string",
    value: input.birthdate
}, _errorFactory)) && (("object" === typeof input.gender && null !== input.gender || $guard(_exceptionable, {
    path: _path + ".gender",
    expected: "(__type | __type.o1)",
    value: input.gender
}, _errorFactory)) && $au0(input.gender, _path + ".gender", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".gender",
    expected: "(__type | __type.o1)",
    value: input.gender
}, _errorFactory)) && (("object" === typeof input.pronouns && null !== input.pronouns || $guard(_exceptionable, {
    path: _path + ".pronouns",
    expected: "(__type.o2 | __type.o3)",
    value: input.pronouns
}, _errorFactory)) && $au1(input.pronouns, _path + ".pronouns", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".pronouns",
    expected: "(__type.o2 | __type.o3)",
    value: input.pronouns
}, _errorFactory)) && (("object" === typeof input.disabilityInfo && null !== input.disabilityInfo || $guard(_exceptionable, {
    path: _path + ".disabilityInfo",
    expected: "(__type.o4 | __type.o5)",
    value: input.disabilityInfo
}, _errorFactory)) && $au2(input.disabilityInfo, _path + ".disabilityInfo", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".disabilityInfo",
    expected: "(__type.o4 | __type.o5)",
    value: input.disabilityInfo
}, _errorFactory)) && ("boolean" === typeof input.student || $guard(_exceptionable, {
    path: _path + ".student",
    expected: "boolean",
    value: input.student
}, _errorFactory)); const $ao2 = (input, _path, _exceptionable = true) => "male" === input.type || "female" === input.type || "non-binary" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "(\"female\" | \"male\" | \"non-binary\")",
    value: input.type
}, _errorFactory); const $ao3 = (input, _path, _exceptionable = true) => ("other" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "\"other\"",
    value: input.type
}, _errorFactory)) && ("string" === typeof input.other || $guard(_exceptionable, {
    path: _path + ".other",
    expected: "string",
    value: input.other
}, _errorFactory)); const $ao4 = (input, _path, _exceptionable = true) => "he" === input.type || "she" === input.type || "they" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "(\"he\" | \"she\" | \"they\")",
    value: input.type
}, _errorFactory); const $ao5 = (input, _path, _exceptionable = true) => ("other" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "\"other\"",
    value: input.type
}, _errorFactory)) && ("string" === typeof input.other || $guard(_exceptionable, {
    path: _path + ".other",
    expected: "string",
    value: input.other
}, _errorFactory)); const $ao6 = (input, _path, _exceptionable = true) => ("boolean" === typeof input.mobility || $guard(_exceptionable, {
    path: _path + ".mobility",
    expected: "boolean",
    value: input.mobility
}, _errorFactory)) && ("boolean" === typeof input.hearingVision || $guard(_exceptionable, {
    path: _path + ".hearingVision",
    expected: "boolean",
    value: input.hearingVision
}, _errorFactory)) && (false === input.needsAccommodation || $guard(_exceptionable, {
    path: _path + ".needsAccommodation",
    expected: "false",
    value: input.needsAccommodation
}, _errorFactory)); const $ao7 = (input, _path, _exceptionable = true) => ("boolean" === typeof input.mobility || $guard(_exceptionable, {
    path: _path + ".mobility",
    expected: "boolean",
    value: input.mobility
}, _errorFactory)) && ("boolean" === typeof input.hearingVision || $guard(_exceptionable, {
    path: _path + ".hearingVision",
    expected: "boolean",
    value: input.hearingVision
}, _errorFactory)) && (true === input.needsAccommodation || $guard(_exceptionable, {
    path: _path + ".needsAccommodation",
    expected: "true",
    value: input.needsAccommodation
}, _errorFactory)) && ("string" === typeof input.accommodationDescription || $guard(_exceptionable, {
    path: _path + ".accommodationDescription",
    expected: "string",
    value: input.accommodationDescription
}, _errorFactory)); const $au0 = (input, _path, _exceptionable = true) => (() => {
    if ("male" === input.type || "female" === input.type || "non-binary" === input.type)
        return $ao2(input, _path, true && _exceptionable);
    else if ("other" === input.type)
        return $ao3(input, _path, true && _exceptionable);
    else
        return $guard(_exceptionable, {
            path: _path,
            expected: "(__type | __type.o1)",
            value: input
        }, _errorFactory);
})(); const $au1 = (input, _path, _exceptionable = true) => (() => {
    if ("he" === input.type || "she" === input.type || "they" === input.type)
        return $ao4(input, _path, true && _exceptionable);
    else if ("other" === input.type)
        return $ao5(input, _path, true && _exceptionable);
    else
        return $guard(_exceptionable, {
            path: _path,
            expected: "(__type.o2 | __type.o3)",
            value: input
        }, _errorFactory);
})(); const $au2 = (input, _path, _exceptionable = true) => (() => {
    if (false === input.needsAccommodation)
        return $ao6(input, _path, true && _exceptionable);
    else if (true === input.needsAccommodation)
        return $ao7(input, _path, true && _exceptionable);
    else
        return $guard(_exceptionable, {
            path: _path,
            expected: "(__type.o4 | __type.o5)",
            value: input
        }, _errorFactory);
})(); const $au3 = (input, _path, _exceptionable = true) => (() => {
    if ("initial" === input.status)
        return $ao0(input, _path, true && _exceptionable);
    else if ("complete" === input.status)
        return $ao1(input, _path, true && _exceptionable);
    else
        return $guard(_exceptionable, {
            path: _path,
            expected: "(UpdateInitialPersonalInfoCommand | UpdateCompletePersonalInfoCommand)",
            value: input
        }, _errorFactory);
})(); const __is = input => "object" === typeof input && null !== input && $iu3(input); let _errorFactory; return (input, errorFactory) => {
    if (false === __is(input)) {
        _errorFactory = errorFactory;
        ((input, _path, _exceptionable = true) => ("object" === typeof input && null !== input || $guard(true, {
            path: _path + "",
            expected: "(UpdateCompletePersonalInfoCommand | UpdateInitialPersonalInfoCommand)",
            value: input
        }, _errorFactory)) && $au3(input, _path + "", true) || $guard(true, {
            path: _path + "",
            expected: "(UpdateCompletePersonalInfoCommand | UpdateInitialPersonalInfoCommand)",
            value: input
        }, _errorFactory))(input, "$input", true);
    }
    return input;
}; })();
exports.validateUpdateAddressInfoCommand = (() => { const $guard = typia_1.default.createAssert.guard; const $iv1 = new Set(["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"]); const $av3 = new Set(["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"]); const $io0 = input => "complete" === input.status && "regular" === input.type && ("object" === typeof input.currentAddress && null !== input.currentAddress && $io1(input.currentAddress)) && ("object" === typeof input.rentalAssistanceData && null !== input.rentalAssistanceData && $io2(input.rentalAssistanceData)); const $io1 = input => "string" === typeof input.address && (undefined === input.apartment || "string" === typeof input.apartment) && "string" === typeof input.city && true === $iv1.has(input.state) && "string" === typeof input.zip; const $io2 = input => "boolean" === typeof input.recievesRentalAssistance && (Array.isArray(input.rentalAssistanceTypes) && input.rentalAssistanceTypes.every(elem => "section-8-hpd" === elem || "section-8-nycha" === elem || "city-fheps" === elem || "vash-iss" === elem || "tbi-waiver" === elem)) && (undefined === input.otherRentalAssistanceType || "string" === typeof input.otherRentalAssistanceType); const $io3 = input => "complete" === input.status && "no-address" === input.type && ("object" === typeof input.previousAddress && null !== input.previousAddress && $io1(input.previousAddress)) && ("object" === typeof input.rentalAssistanceData && null !== input.rentalAssistanceData && $io2(input.rentalAssistanceData)); const $io4 = input => "complete" === input.status && "shelter" === input.type && ("object" === typeof input.currentAddress && null !== input.currentAddress && $io1(input.currentAddress)) && ("object" === typeof input.previousAddress && null !== input.previousAddress && $io1(input.previousAddress)) && ("object" === typeof input.rentalAssistanceData && null !== input.rentalAssistanceData && $io2(input.rentalAssistanceData)); const $io5 = input => "complete" === input.status && "nycha" === input.type && "boolean" === typeof input.onForm && ("object" === typeof input.currentAddress && null !== input.currentAddress && $io1(input.currentAddress)) && ("object" === typeof input.rentalAssistanceData && null !== input.rentalAssistanceData && $io2(input.rentalAssistanceData)); const $iu0 = input => (() => {
    if ("regular" === input.type)
        return $io0(input);
    else if ("no-address" === input.type)
        return $io3(input);
    else if ("shelter" === input.type)
        return $io4(input);
    else if ("nycha" === input.type)
        return $io5(input);
    else
        return false;
})(); const $ao0 = (input, _path, _exceptionable = true) => ("complete" === input.status || $guard(_exceptionable, {
    path: _path + ".status",
    expected: "\"complete\"",
    value: input.status
}, _errorFactory)) && ("regular" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "\"regular\"",
    value: input.type
}, _errorFactory)) && (("object" === typeof input.currentAddress && null !== input.currentAddress || $guard(_exceptionable, {
    path: _path + ".currentAddress",
    expected: "AddressDataDto",
    value: input.currentAddress
}, _errorFactory)) && $ao1(input.currentAddress, _path + ".currentAddress", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".currentAddress",
    expected: "AddressDataDto",
    value: input.currentAddress
}, _errorFactory)) && (("object" === typeof input.rentalAssistanceData && null !== input.rentalAssistanceData || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceData",
    expected: "RentalAssistanceDataDto",
    value: input.rentalAssistanceData
}, _errorFactory)) && $ao2(input.rentalAssistanceData, _path + ".rentalAssistanceData", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceData",
    expected: "RentalAssistanceDataDto",
    value: input.rentalAssistanceData
}, _errorFactory)); const $ao1 = (input, _path, _exceptionable = true) => ("string" === typeof input.address || $guard(_exceptionable, {
    path: _path + ".address",
    expected: "string",
    value: input.address
}, _errorFactory)) && (undefined === input.apartment || "string" === typeof input.apartment || $guard(_exceptionable, {
    path: _path + ".apartment",
    expected: "(string | undefined)",
    value: input.apartment
}, _errorFactory)) && ("string" === typeof input.city || $guard(_exceptionable, {
    path: _path + ".city",
    expected: "string",
    value: input.city
}, _errorFactory)) && (true === $av3.has(input.state) || $guard(_exceptionable, {
    path: _path + ".state",
    expected: "(\"AK\" | \"AL\" | \"AR\" | \"AZ\" | \"CA\" | \"CO\" | \"CT\" | \"DC\" | \"DE\" | \"FL\" | \"GA\" | \"HI\" | \"IA\" | \"ID\" | \"IL\" | \"IN\" | \"KS\" | \"KY\" | \"LA\" | \"MA\" | \"MD\" | \"ME\" | \"MI\" | \"MN\" | \"MO\" | \"MS\" | \"MT\" | \"NC\" | \"ND\" | \"NE\" | \"NH\" | \"NJ\" | \"NM\" | \"NV\" | \"NY\" | \"OH\" | \"OK\" | \"OR\" | \"PA\" | \"PR\" | \"RI\" | \"SC\" | \"SD\" | \"TN\" | \"TX\" | \"UT\" | \"VA\" | \"VT\" | \"WA\" | \"WI\" | \"WV\" | \"WY\")",
    value: input.state
}, _errorFactory)) && ("string" === typeof input.zip || $guard(_exceptionable, {
    path: _path + ".zip",
    expected: "string",
    value: input.zip
}, _errorFactory)); const $ao2 = (input, _path, _exceptionable = true) => ("boolean" === typeof input.recievesRentalAssistance || $guard(_exceptionable, {
    path: _path + ".recievesRentalAssistance",
    expected: "boolean",
    value: input.recievesRentalAssistance
}, _errorFactory)) && ((Array.isArray(input.rentalAssistanceTypes) || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceTypes",
    expected: "Array<\"section-8-hpd\" | \"section-8-nycha\" | \"city-fheps\" | \"vash-iss\" | \"tbi-waiver\">",
    value: input.rentalAssistanceTypes
}, _errorFactory)) && input.rentalAssistanceTypes.every((elem, _index4) => "section-8-hpd" === elem || "section-8-nycha" === elem || "city-fheps" === elem || "vash-iss" === elem || "tbi-waiver" === elem || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceTypes[" + _index4 + "]",
    expected: "(\"city-fheps\" | \"section-8-hpd\" | \"section-8-nycha\" | \"tbi-waiver\" | \"vash-iss\")",
    value: elem
}, _errorFactory)) || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceTypes",
    expected: "Array<\"section-8-hpd\" | \"section-8-nycha\" | \"city-fheps\" | \"vash-iss\" | \"tbi-waiver\">",
    value: input.rentalAssistanceTypes
}, _errorFactory)) && (undefined === input.otherRentalAssistanceType || "string" === typeof input.otherRentalAssistanceType || $guard(_exceptionable, {
    path: _path + ".otherRentalAssistanceType",
    expected: "(string | undefined)",
    value: input.otherRentalAssistanceType
}, _errorFactory)); const $ao3 = (input, _path, _exceptionable = true) => ("complete" === input.status || $guard(_exceptionable, {
    path: _path + ".status",
    expected: "\"complete\"",
    value: input.status
}, _errorFactory)) && ("no-address" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "\"no-address\"",
    value: input.type
}, _errorFactory)) && (("object" === typeof input.previousAddress && null !== input.previousAddress || $guard(_exceptionable, {
    path: _path + ".previousAddress",
    expected: "AddressDataDto",
    value: input.previousAddress
}, _errorFactory)) && $ao1(input.previousAddress, _path + ".previousAddress", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".previousAddress",
    expected: "AddressDataDto",
    value: input.previousAddress
}, _errorFactory)) && (("object" === typeof input.rentalAssistanceData && null !== input.rentalAssistanceData || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceData",
    expected: "RentalAssistanceDataDto",
    value: input.rentalAssistanceData
}, _errorFactory)) && $ao2(input.rentalAssistanceData, _path + ".rentalAssistanceData", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceData",
    expected: "RentalAssistanceDataDto",
    value: input.rentalAssistanceData
}, _errorFactory)); const $ao4 = (input, _path, _exceptionable = true) => ("complete" === input.status || $guard(_exceptionable, {
    path: _path + ".status",
    expected: "\"complete\"",
    value: input.status
}, _errorFactory)) && ("shelter" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "\"shelter\"",
    value: input.type
}, _errorFactory)) && (("object" === typeof input.currentAddress && null !== input.currentAddress || $guard(_exceptionable, {
    path: _path + ".currentAddress",
    expected: "AddressDataDto",
    value: input.currentAddress
}, _errorFactory)) && $ao1(input.currentAddress, _path + ".currentAddress", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".currentAddress",
    expected: "AddressDataDto",
    value: input.currentAddress
}, _errorFactory)) && (("object" === typeof input.previousAddress && null !== input.previousAddress || $guard(_exceptionable, {
    path: _path + ".previousAddress",
    expected: "AddressDataDto",
    value: input.previousAddress
}, _errorFactory)) && $ao1(input.previousAddress, _path + ".previousAddress", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".previousAddress",
    expected: "AddressDataDto",
    value: input.previousAddress
}, _errorFactory)) && (("object" === typeof input.rentalAssistanceData && null !== input.rentalAssistanceData || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceData",
    expected: "RentalAssistanceDataDto",
    value: input.rentalAssistanceData
}, _errorFactory)) && $ao2(input.rentalAssistanceData, _path + ".rentalAssistanceData", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceData",
    expected: "RentalAssistanceDataDto",
    value: input.rentalAssistanceData
}, _errorFactory)); const $ao5 = (input, _path, _exceptionable = true) => ("complete" === input.status || $guard(_exceptionable, {
    path: _path + ".status",
    expected: "\"complete\"",
    value: input.status
}, _errorFactory)) && ("nycha" === input.type || $guard(_exceptionable, {
    path: _path + ".type",
    expected: "\"nycha\"",
    value: input.type
}, _errorFactory)) && ("boolean" === typeof input.onForm || $guard(_exceptionable, {
    path: _path + ".onForm",
    expected: "boolean",
    value: input.onForm
}, _errorFactory)) && (("object" === typeof input.currentAddress && null !== input.currentAddress || $guard(_exceptionable, {
    path: _path + ".currentAddress",
    expected: "AddressDataDto",
    value: input.currentAddress
}, _errorFactory)) && $ao1(input.currentAddress, _path + ".currentAddress", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".currentAddress",
    expected: "AddressDataDto",
    value: input.currentAddress
}, _errorFactory)) && (("object" === typeof input.rentalAssistanceData && null !== input.rentalAssistanceData || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceData",
    expected: "RentalAssistanceDataDto",
    value: input.rentalAssistanceData
}, _errorFactory)) && $ao2(input.rentalAssistanceData, _path + ".rentalAssistanceData", true && _exceptionable) || $guard(_exceptionable, {
    path: _path + ".rentalAssistanceData",
    expected: "RentalAssistanceDataDto",
    value: input.rentalAssistanceData
}, _errorFactory)); const $au0 = (input, _path, _exceptionable = true) => (() => {
    if ("regular" === input.type)
        return $ao0(input, _path, true && _exceptionable);
    else if ("no-address" === input.type)
        return $ao3(input, _path, true && _exceptionable);
    else if ("shelter" === input.type)
        return $ao4(input, _path, true && _exceptionable);
    else if ("nycha" === input.type)
        return $ao5(input, _path, true && _exceptionable);
    else
        return $guard(_exceptionable, {
            path: _path,
            expected: "(RegularAddressInfoDto | NoAddressInfoDto | ShelterAddressInfoDto | NYCHAAddressInfoDto)",
            value: input
        }, _errorFactory);
})(); const __is = input => "object" === typeof input && null !== input && $iu0(input); let _errorFactory; return (input, errorFactory) => {
    if (false === __is(input)) {
        _errorFactory = errorFactory;
        ((input, _path, _exceptionable = true) => ("object" === typeof input && null !== input || $guard(true, {
            path: _path + "",
            expected: "(NYCHAAddressInfoDto | NoAddressInfoDto | RegularAddressInfoDto | ShelterAddressInfoDto)",
            value: input
        }, _errorFactory)) && $au0(input, _path + "", true) || $guard(true, {
            path: _path + "",
            expected: "(NYCHAAddressInfoDto | NoAddressInfoDto | RegularAddressInfoDto | ShelterAddressInfoDto)",
            value: input
        }, _errorFactory))(input, "$input", true);
    }
    return input;
}; })();
